import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CfetPageNamesConstant, CfetBaseComponent } from '../../../cfet-core';

@Component({
    selector: 'app-customer-documents-review-utf',
    templateUrl: './customer-documents-review-utf.component.html',
    styleUrls: ['./customer-documents-review-utf.component.scss'],
    standalone: false
})
export class CustomerDocumentsReviewUtfComponent extends CfetBaseComponent implements OnInit {

  @Output() showCancelModal = new EventEmitter<any>();
  @Output() clearTimeout = new EventEmitter<any>(false);
  constructor(private router: Router) { super(); }

  ngOnInit() {
    window.scrollTo(0, 0);
  }

  continueToProfile(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.clearTimeout.emit(true);
      this.router.navigate([CfetPageNamesConstant.CUSTOMER_PROFILE_UTF]);      
    }
  }

  cancel(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showCancelModal.emit(true);
    }
  }

}
